import {
    MY_PAGE_AUTH_COMPLETE,
} from '../authentication/types';

export default ({ dispatch, getState }) => next => (action) => {
    const { type, payload } = action;
    const { config } = getState();

    const actionOfType = lookedFor => type === lookedFor;
    const filterDelayedActions = (lookedFor, delayedMap = []) =>
        delayedMap.filter(object => object.initializer === lookedFor);

    if (actionOfType(MY_PAGE_AUTH_COMPLETE) && config.actions) {
        config.actions.forEach((item) => {
            dispatch(item.action(item.params));
        });
    }

    filterDelayedActions(type, config.delayedActions).forEach((item) => {
        dispatch(item.action(item.params, payload, getState()));
    });

    return next(action);
};
